export const pageTitleId = "emplopyee-id";
export const ImportButton = "import-button";
export const AddButton = "add-button";
export const OnboardButton = "onboard-button";
